module.exports = __webpack_public_path__ + "static/media/default-image.28e199c3.svg";